/* Aurex Toys – theme.js
   Shopify-backed replacement for the mock JS in the HTML build.
   Cart   -> Shopify Cart AJAX API
   Filters-> storefront filtering + section rendering
   Wishlist -> localStorage
*/
(function () {
  'use strict';

  var T = window.theme || {};
  var routes = T.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function icons() { if (window.lucide && window.lucide.createIcons) { window.lucide.createIcons(); } }

  /* ---------------------------------------------------------- money */
  function fmtNum(n, decimals, thousands, decimalSep) {
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimalSep + parts[1] : parts[0];
  }
  function formatMoney(cents) {
    var fmt = T.moneyFormat || 'Rs. {{amount_no_decimals}}';
    var n = (Number(cents) || 0) / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmtNum(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmtNum(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmtNum(n, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmtNum(n, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmtNum(n, 0, ' ', ','); break;
      default: value = fmtNum(n, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---------------------------------------------------------- theme toggle */
  function initThemeToggle() {
    var btn = $('#themeToggle');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var dark = document.documentElement.classList.toggle('dark');
      try { localStorage.setItem('aurex-theme', dark ? 'dark' : 'light'); } catch (e) {}
    });
  }

  /* ---------------------------------------------------------- drawers */
  function toggle(id, open) {
    var el = document.getElementById(id);
    if (el) el.classList.toggle('hidden', !open);
  }
  window.toggleMobileNav = function (open) { toggle('mobileNavDrawer', open); };
  window.toggleCartDrawer = function (open) { toggle('cartDrawer', open); };
  window.toggleWishlistDrawer = function (open) { if (open) renderWishlist(); toggle('wishlistDrawer', open); };
  window.toggleMobileFilters = function (open) { toggle('mobileFilterDrawer', open); };

  function initDrawers() {
    // click on the dark backdrop (not the panel) closes the drawer
    $$('[data-drawer-backdrop]').forEach(function (bd) {
      bd.addEventListener('click', function (e) { if (e.target === bd) bd.classList.add('hidden'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') $$('[data-drawer-backdrop]').forEach(function (bd) { bd.classList.add('hidden'); });
    });
  }

  /* ---------------------------------------------------------- announcements */
  function initAnnouncements() {
    var el = $('#announcementText');
    if (!el) return;
    var list = [];
    try { list = JSON.parse(el.getAttribute('data-announcements') || '[]'); } catch (e) {}
    if (list.length < 2) return;
    var i = 0;
    setInterval(function () {
      el.style.opacity = 0;
      setTimeout(function () { i = (i + 1) % list.length; el.textContent = list[i]; el.style.opacity = 1; }, 400);
    }, 4000);
  }

  /* ---------------------------------------------------------- cart (Shopify AJAX API) */
  var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function getCart() {
    return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  // opts.onError(err) – optional; without it errors show as an alert (cards, wishlist)
  function addToCart(variantId, quantity, opts) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST', headers: jsonHeaders, credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    }).then(function (r) {
      if (!r.ok) { return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to bag.'); }); }
      return refreshCart().then(function () { window.toggleCartDrawer(true); return true; });
    }).catch(function (err) {
      if (opts && opts.onError) opts.onError(err); else alert(err.message);
      return false;
    });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST', headers: jsonHeaders, credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCart);
  }

  function refreshCart() { return getCart().then(renderCart); }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderCart(cart) {
    var badge = $('#cartBadge'), total = $('#cartHeaderTotal'), subtotal = $('#cartSubtotal'), box = $('[data-cart-items]');
    if (badge) badge.textContent = cart.item_count;
    if (total) total.textContent = formatMoney(cart.total_price);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (!box) return;
    if (!cart.items.length) {
      box.innerHTML = '<p class="text-center text-xs text-slate-400 py-8">Your bag is empty.</p>';
      return;
    }
    box.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" class="w-10 h-10 object-cover rounded">' : '<div class="w-10 h-10 rounded bg-slate-200 dark:bg-slate-700"></div>';
      return '<div class="flex items-center space-x-3 p-2 bg-slate-50 dark:bg-slate-800 rounded-xl">' + img +
        '<div class="flex-1 min-w-0"><h4 class="font-bold text-xs line-clamp-1">' + escapeHtml(item.product_title) + '</h4>' +
        '<p class="text-[11px] text-coral-600">' + formatMoney(item.final_price) + ' x ' + item.quantity + '</p></div>' +
        '<button type="button" data-remove-line="' + escapeHtml(item.key) + '" class="p-1 text-slate-400 hover:text-coral-500" aria-label="Remove"><i data-lucide="x" class="w-4 h-4"></i></button></div>';
    }).join('');
    icons();
  }

  /* ---------------------------------------------------------- wishlist (localStorage) */
  var WL_KEY = 'aurex-wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function setWishlist(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {} }

  function toggleWishlistItem(p) {
    var list = getWishlist();
    var i = list.findIndex(function (x) { return x.handle === p.handle; });
    if (i > -1) list.splice(i, 1); else list.push(p);
    setWishlist(list);
    renderWishlist();
    markHearts();
  }

  function markHearts() {
    var handles = {};
    getWishlist().forEach(function (x) { handles[x.handle] = true; });
    var badge = $('#wishlistBadge');
    var count = Object.keys(handles).length;
    if (badge) { badge.textContent = count; badge.classList.toggle('hidden', count === 0); }
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = !!handles[btn.getAttribute('data-handle')];
      btn.classList.toggle('text-coral-500', on);
      var svg = btn.querySelector('svg');
      if (svg) svg.classList.toggle('fill-current', on);
    });
  }

  function renderWishlist() {
    var box = $('[data-wishlist-items]');
    if (!box) return;
    var list = getWishlist();
    if (!list.length) {
      box.innerHTML = '<p class="text-center text-xs text-slate-400 py-8">Nothing saved yet. Tap the heart on any toy.</p>';
      return;
    }
    box.innerHTML = list.map(function (p) {
      var img = p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" class="w-10 h-10 object-cover rounded">' : '<div class="w-10 h-10 rounded bg-slate-200 dark:bg-slate-700"></div>';
      var action = p.variantId
        ? '<button type="button" data-add-to-cart data-variant-id="' + p.variantId + '" class="px-3 py-1.5 bg-coral-600 hover:bg-coral-700 text-white font-bold rounded-xl text-xs">Add</button>'
        : '<a href="' + escapeHtml(p.url) + '" class="px-3 py-1.5 bg-coral-600 hover:bg-coral-700 text-white font-bold rounded-xl text-xs">View</a>';
      return '<div class="flex items-center space-x-3 p-2 bg-slate-50 dark:bg-slate-800 rounded-xl">' + img +
        '<div class="flex-1 min-w-0"><h4 class="font-bold text-xs line-clamp-1"><a href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></h4>' +
        '<p class="text-[11px] text-coral-600">' + formatMoney(p.price) + '</p></div>' + action +
        '<button type="button" data-wishlist-remove="' + escapeHtml(p.handle) + '" class="p-1 text-slate-400 hover:text-coral-500" aria-label="Remove"><i data-lucide="x" class="w-4 h-4"></i></button></div>';
    }).join('');
    icons();
  }

  /* ---------------------------------------------------------- delegated clicks */
  function initClicks() {
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add-to-cart]');
      if (add) { e.preventDefault(); addToCart(add.getAttribute('data-variant-id'), 1); return; }

      var rm = e.target.closest('[data-remove-line]');
      if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-remove-line'), 0); return; }

      var wl = e.target.closest('[data-wishlist-toggle]');
      if (wl) {
        e.preventDefault();
        var p = null;
        try { p = JSON.parse(wl.getAttribute('data-product')); } catch (err) {}
        if (p) toggleWishlistItem(p);
        return;
      }

      var wlr = e.target.closest('[data-wishlist-remove]');
      if (wlr) {
        e.preventDefault();
        var handle = wlr.getAttribute('data-wishlist-remove');
        setWishlist(getWishlist().filter(function (x) { return x.handle !== handle; }));
        renderWishlist(); markHearts();
        return;
      }
    });
  }

  /* ---------------------------------------------------------- product page: gallery */
  // Swipeable scroll-snap gallery + thumbnails + arrows. Returns { showMedia(id, instant) }.
  function initGallery(root) {
    var noop = { showMedia: function () {} };
    var track = $('[data-gallery-track]', root);
    if (!track) return noop;
    var slides = $$('[data-gallery-slide]', track);
    if (slides.length < 2) return noop;
    var thumbs = $$('[data-gallery-thumb]', root);
    var strip = $('[data-gallery-thumbs]', root);
    var counter = $('[data-gallery-counter]', root);
    var current = 0, settle = null;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('ring-2', on);
        t.classList.toggle('ring-coral-600', on);
        t.classList.toggle('opacity-60', !on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && strip) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
      });
      // pause any product video that scrolled out of view
      slides.forEach(function (s, n) { if (n !== i) $$('video', s).forEach(function (v) { v.pause(); }); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }

    function go(i, instant) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }

    // after a swipe (or any scroll) settles, sync thumbnails + counter with the visible slide
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
      }, 90);
    }, { passive: true });

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });
    window.addEventListener('resize', function () { go(current, true); });

    return {
      showMedia: function (mediaId, instant) {
        for (var n = 0; n < slides.length; n++) {
          if (slides[n].getAttribute('data-media-id') === String(mediaId)) { if (n !== current || instant) go(n, instant); return; }
        }
      }
    };
  }

  /* ---------------------------------------------------------- product page: form */
  function stockState(v, lowStock) {
    if (!v || !v.available) return 'out';
    if (v.inventory_management === 'shopify') {
      if (v.inventory_quantity <= 0) return 'backorder';
      if (v.inventory_quantity <= lowStock) return 'low';
    }
    return 'in';
  }

  function initProductPage(scope) {
    var root = $('[data-product-section]', scope);
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', 'true');

    var data = {};
    try { data = JSON.parse(($('[data-product-json]', root) || {}).textContent || '{}'); } catch (e) {}
    var variants = data.variants || [];
    var lowStock = Number(root.getAttribute('data-low-stock')) || 0;
    var gallery = initGallery(root);

    var form = $('[data-product-form]', root);
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var qty = $('[data-qty-input]', root);
    var button = $('[data-add-button]', root);
    var label = $('[data-add-label]', root);
    var errorBox = $('[data-product-error]', root);
    var wa = $('[data-whatsapp-order]', root);
    var optionInputs = $$('[data-option-input]', root);
    var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || null;

    function selectedOptions() {
      var opts = [];
      optionInputs.forEach(function (input) { if (input.checked) opts[Number(input.getAttribute('data-option-index'))] = input.value; });
      return opts;
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0] || null;
    }

    // strike through option values that are sold out / don't exist with the other current choices
    function markAvailability() {
      var opts = selectedOptions();
      optionInputs.forEach(function (input) {
        var test = opts.slice();
        test[Number(input.getAttribute('data-option-index'))] = input.value;
        var v = findVariant(test);
        var pill = input.nextElementSibling;
        if (pill) pill.toggleAttribute('data-unavailable', !v || !v.available);
      });
    }

    function clampQty() {
      if (!qty) return 1;
      var n = Math.floor(Number(qty.value)) || 1;
      var max = Number(qty.getAttribute('max')) || 0;
      if (n < 1) n = 1;
      if (max && n > max) n = max;
      qty.value = n;
      return n;
    }

    function showError(msg) {
      if (!errorBox) { alert(msg); return; }
      errorBox.textContent = msg;
      errorBox.classList.toggle('hidden', !msg);
    }

    function renderPrice(v) {
      var price = $('[data-product-price]', root), compare = $('[data-product-compare]', root);
      var save = $('[data-product-savings]', root), badge = $('[data-sale-badge]', root);
      var onSale = v.compare_at_price > v.price;
      if (price) price.textContent = formatMoney(v.price);
      if (compare) { compare.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compare.classList.toggle('hidden', !onSale); }
      if (save) { save.textContent = onSale ? 'Save ' + formatMoney(v.compare_at_price - v.price) : ''; save.classList.toggle('hidden', !onSale); }
      if (badge) { badge.textContent = onSale ? '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : ''; badge.classList.toggle('hidden', !onSale); }
    }

    function renderStock(v) {
      var state = stockState(v, lowStock);
      $$('[data-stock]', root).forEach(function (el) { el.classList.toggle('hidden', el.getAttribute('data-stock') !== state); });
      var count = $('[data-stock-count]', root);
      if (count && v) count.textContent = v.inventory_quantity;
      if (qty) {
        if (v && v.inventory_management === 'shopify' && v.inventory_policy === 'deny' && v.inventory_quantity > 0) qty.setAttribute('max', v.inventory_quantity);
        else qty.removeAttribute('max');
        clampQty();
      }
    }

    function renderButton(v) {
      var ok = !!(v && v.available);
      if (button) button.disabled = !ok;
      if (label) label.textContent = !v ? 'Unavailable' : (ok ? 'Add to Bag' : 'Sold Out');
    }

    function renderWhatsApp() {
      if (!wa || !current) return;
      var lines = [
        'Hi ' + data.shop + "! I'd like to order:",
        data.title + (data.hasVariants ? ' (' + current.title + ')' : ''),
        'Qty: ' + clampQty(),
        'Price: ' + formatMoney(current.price),
        data.url + (data.hasVariants ? '?variant=' + current.id : '')
      ];
      wa.href = 'https://wa.me/' + wa.getAttribute('data-number') + '?text=' + encodeURIComponent(lines.join('\n'));
    }

    function onVariantChange(v) {
      current = v;
      showError('');
      renderButton(v);
      renderStock(v);
      $$('[data-option-selected]', root).forEach(function (el) {
        el.textContent = selectedOptions()[Number(el.getAttribute('data-option-selected'))] || '';
      });
      markAvailability();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      renderPrice(v);
      renderWhatsApp();
      var sku = $('[data-product-sku]', root), skuRow = $('[data-sku-row]', root);
      if (sku) sku.textContent = v.sku || '';
      if (skuRow) skuRow.classList.toggle('hidden', !v.sku);
      if (v.featured_media_id) gallery.showMedia(v.featured_media_id);
      if (data.hasVariants && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () { onVariantChange(findVariant(selectedOptions())); });
    });

    var minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    function step(d) { if (!qty) return; qty.value = clampQty() + d; clampQty(); renderWhatsApp(); }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
    if (qty) qty.addEventListener('change', function () { clampQty(); renderWhatsApp(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = current ? current.id : (idInput && idInput.value);
      if (!id || (current && !current.available)) return;
      showError('');
      if (button) button.disabled = true;
      if (label) label.textContent = 'Adding…';
      addToCart(id, clampQty(), { onError: function (err) { showError(err.message); } })
        .then(function () { renderButton(current || { available: true }); });
    });

    markAvailability();
    if (current && current.featured_media_id) gallery.showMedia(current.featured_media_id, true);
  }

  /* ---------------------------------------------------------- product recommendations */
  // The section renders a fallback grid; Shopify's recommendations replace it only
  // when they bring at least as many toys (a new store often gets 0–1 back).
  function initRecommendations(scope) {
    var box = $('[data-recommendations]', scope);
    if (!box || !box.getAttribute('data-url')) return;
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (!fresh || !fresh.innerHTML.trim()) return;
      var have = $$('[data-product-card]', box).length;
      var got = $$('[data-product-card]', fresh).length;
      if (got >= have || got >= 4) { box.innerHTML = fresh.innerHTML; icons(); markHearts(); }
    }).catch(function () {});
  }

  /* ---------------------------------------------------------- 3-tap picker */
  var picker = { who: null, age: null, budget: null };
  window.handlePickerStep = function (step, val) {
    picker[step] = val;
    if (step === 'who') {
      $('#pickerStep1').classList.add('hidden');
      $('#pickerStep2').classList.remove('hidden');
      var d2 = $('#pDot2'); if (d2) d2.className = 'h-2 flex-1 rounded-full bg-coral-600';
      return;
    }
    if (step === 'age') {
      $('#pickerStep2').classList.add('hidden');
      $('#pickerStep3').classList.remove('hidden');
      var d3 = $('#pDot3'); if (d3) d3.className = 'h-2 flex-1 rounded-full bg-coral-600';
      return;
    }
    // budget chosen -> go to the collection with filters applied
    var wrap = $('[data-picker]');
    var base = (picker.who === 'Collector' && wrap && wrap.getAttribute('data-collector')) ? wrap.getAttribute('data-collector') : (wrap ? wrap.getAttribute('data-target') : routes.allProducts);
    var params = new URLSearchParams();
    if (picker.age) params.append('filter.p.tag', 'age-' + String(picker.age).toLowerCase());
    if (val === 'under999') { params.append('filter.v.price.lte', '999'); }
    else if (val === '1k-3k') { params.append('filter.v.price.gte', '1000'); params.append('filter.v.price.lte', '3000'); }
    else if (val === '3k-7k') { params.append('filter.v.price.gte', '3000'); params.append('filter.v.price.lte', '7000'); }
    else { params.append('filter.v.price.gte', '7000'); }
    window.location.href = base + '?' + params.toString();
  };

  /* ---------------------------------------------------------- collection filters (section rendering) */
  function applyFilters(form) {
    var params = new URLSearchParams(new FormData(form));
    var range = form.querySelector('input[type="range"]');
    if (range && Number(range.value) >= Number(range.max)) params.delete(range.name);
    var section = $('[data-collection-section]');
    var sectionId = section && section.getAttribute('data-section-id');
    var url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    if (!sectionId) { window.location.href = url; return; }
    var grid = $('[data-catalog-grid]');
    if (grid) grid.classList.add('opacity-50');
    fetch(url + (params.toString() ? '&' : '?') + 'section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-catalog-grid]', '[data-catalog-count]', '[data-pagination]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), old = $(sel);
          if (fresh && old) old.innerHTML = fresh.innerHTML;
        });
        history.replaceState({}, '', url);
        icons(); markHearts();
      })
      .catch(function () { window.location.href = url; })
      .then(function () { if (grid) grid.classList.remove('opacity-50'); });
  }

  function initCollectionFilters() {
    $$('[data-filter-form]').forEach(function (form) {
      form.addEventListener('change', function (e) { if (e.target.type !== 'range') applyFilters(form); });
      form.addEventListener('submit', function (e) { e.preventDefault(); applyFilters(form); });
      $$('input[type="range"]', form).forEach(function (r) {
        r.addEventListener('input', function () {
          $$('[data-price-label]', form).forEach(function (l) { l.textContent = formatMoney(Number(r.value) * 100); });
        });
        r.addEventListener('change', function () { applyFilters(form); });
      });
    });
  }

  /* ---------------------------------------------------------- track order */
  function initTrackOrder() {
    var btn = $('[data-track-button]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var input = $('#trackInput');
      var id = input ? input.value.trim() : '';
      var tpl = btn.getAttribute('data-tracking-url');
      if (tpl && id) window.open(tpl.replace('{id}', encodeURIComponent(id)), '_blank', 'noopener');
      var result = $('#trackResult');
      if (result) result.classList.remove('hidden');
    });
  }

  /* ---------------------------------------------------------- boot */
  function init() {
    icons();
    initThemeToggle();
    initDrawers();
    initAnnouncements();
    initClicks();
    initProductPage();
    initRecommendations();
    initCollectionFilters();
    initTrackOrder();
    renderWishlist();
    markHearts();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Re-run icons + hearts (and the product page) when the Shopify theme editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) {
    icons(); markHearts();
    initProductPage(e.target);
    initRecommendations(e.target);
  });

  window.AurexToys = { formatMoney: formatMoney, addToCart: addToCart, refreshCart: refreshCart, renderWishlist: renderWishlist };
})();
